/**
 * Check if the document is scrolled by at least X pixels.
 * @param pixels
 * @returns {boolean}
 */
const isScrolledBy = pixels => document.body.scrollTop >= pixels;

/**
 * Display and manipulate the Live Chat option when container exists and parameters are met.
 */
const handleScroll = () => {
    const container = document.getElementById('liveChatContainer');

    // Don't continue if we're not going to be rendering anywhere.
    if(!container) {
        return;
    }

    let width = '300px';
    let text = 'Live Chat with us ';

    if(window.matchMedia('(max-width: 767px)').matches) {
        width = '80px'
        text = ''
    } else if (isScrolledBy(700)) {
        width = '100px'
        text = ''
    } else if (isScrolledBy(300)) {
        width = '200px';
        text = 'Live Chat '
    }

    container.style.width = width;
    container.innerHTML = `${text}<img class="chat-icon" src="/images/chat-icon-blue.svg" alt="Live Chat"/>`
}

document.addEventListener('scroll', handleScroll);
